<div class="card border shadow-sm">
	<div
		class="card-header"
		[ngClass]="cardHeaderBackgroud !== '' ? cardHeaderBackgroud : 'bg-light'">
		<div class="d-flex flex-wrap gap-2 justify-content-between">
			<div class="d-flex justify-content-between">
				<h6 [ngClass]="iconHeader !== '' ? 'hstack gap-2 mb-0' : 'mb-0'">
					<i [ngClass]="iconHeader !== '' ? iconHeader : 'd-none'"></i>
					{{ textHeader }}
				</h6>
				<ng-content select="[header]"></ng-content>
			</div>
			<div [class]="'d-flex gap-2' + (inverterBotoes ? ' row-reverse' : '')">
				<ng-container *ngIf="buttons.length > 0; else legacyButtons">
					<div *ngFor="let cardButton of buttons">
						<seira-button
							*ngIf="cardButton.link"
							[link]="cardButton.link"
							[buttonStyle]="cardButton.buttonStyle ?? 'cancel'"
							[loading]="cardButton.loading ?? false"
							[disabledButton]="cardButton.disabled ?? false">
							<div *ngIf="cardButton.loading" class="me-1">
								<mat-spinner
									class="branco"
									[diameter]="20"
									[color]="'#FFFFFF'" />
							</div>

							{{
								cardButton.loading
									? cardButton.loadingLabel || cardButton.label
									: cardButton.label
							}}
						</seira-button>
						<seira-button
							*ngIf="!cardButton.link"
							(clicked)="_cardButtonAction(cardButton)"
							[buttonStyle]="cardButton.buttonStyle ?? 'cancel'"
							[loading]="cardButton.loading ?? false"
							[disabledButton]="cardButton.disabled ?? false">
							<div *ngIf="cardButton.loading" class="me-1">
								<mat-spinner
									class="branco"
									[diameter]="20"
									[color]="'#FFFFFF'" />
							</div>

							{{
								cardButton.loading
									? cardButton.loadingLabel || cardButton.label
									: cardButton.label
							}}
						</seira-button>
					</div>
				</ng-container>
				<ng-template #legacyButtons>
					<div *ngIf="hasButton">
						<seira-button
							*ngIf="buttonLink"
							[link]="buttonLink!"
							[buttonStyle]="mappedButtonStyle">
							{{ buttonLabel }}
						</seira-button>
						<seira-button
							*ngIf="!buttonLink"
							(clicked)="_buttonAction()"
							[buttonStyle]="mappedButtonStyle">
							{{ buttonLabel }}
						</seira-button>
					</div>
					<div *ngIf="hasSecondaryButton">
						<seira-button
							*ngIf="secondaryButtonLink"
							[link]="secondaryButtonLink!"
							[buttonStyle]="mappedSecondaryButtonStyle"
							[loading]="isLoadingSecondaryButton"
							[disabledButton]="isLoadingSecondaryButton">
							<div *ngIf="isLoadingSecondaryButton" class="me-1">
								<mat-spinner
									class="branco"
									[diameter]="20"
									[color]="'#FFFFFF'" />
							</div>

							{{
								isLoadingSecondaryButton
									? secondaryButtonLoadingLabel
									: secondaryButtonLabel
							}}
						</seira-button>
						<seira-button
							*ngIf="!secondaryButtonLink"
							(clicked)="_secondaryButtonAction()"
							[buttonStyle]="mappedSecondaryButtonStyle"
							[loading]="isLoadingSecondaryButton"
							[disabledButton]="isLoadingSecondaryButton">
							<div *ngIf="isLoadingSecondaryButton" class="me-1">
								<mat-spinner
									class="branco"
									[diameter]="20"
									[color]="'#FFFFFF'" />
							</div>
							{{
								isLoadingSecondaryButton
									? secondaryButtonLoadingLabel
									: secondaryButtonLabel
							}}
						</seira-button>
					</div>
				</ng-template>
			</div>
		</div>
	</div>
	<div class="card-body" [ngClass]="[bodyClass, isSmallScreen ? ' p-1' : '']">
		<ng-content></ng-content>
	</div>
	<ng-container
		*ngTemplateOutlet="footerContent ? footerContent : null"></ng-container>
</div>
